import React from "react";
import { motion } from "framer-motion";
import { sectionVariants } from "../../constants/animations";
import { EXPERIENCES } from "./Experience.constants";

const Experience: React.FC = () => {
  return (
    <motion.section
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="py-20 px-6"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-bold mb-12 text-center gradient-text">
          Professional Experience
        </h2>
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute left-0 md:left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-blue-500 via-purple-500 to-pink-500" />

          {EXPERIENCES.map((exp, i) => (
            <motion.div
              key={exp.title + exp.company}
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
              className="relative mb-12 ml-8 md:ml-16"
            >
              {/* Timeline dot */}
              <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ delay: i * 0.1 + 0.2 }}
                viewport={{ once: true }}
                className="absolute -left-8 md:-left-12 w-4 h-4 rounded-full bg-blue-500 border-4 border-slate-900"
              />

              <div className="glass rounded-2xl p-6 hover:scale-[1.01] transition-transform">
                <div className="flex flex-wrap items-start justify-between gap-2 mb-3">
                  <div>
                    <h3 className="text-xl font-bold text-white">
                      {exp.title}
                    </h3>
                    <p className="text-blue-400 font-medium">{exp.company}</p>
                    <p className="text-sm text-slate-400">{exp.location}</p>
                  </div>
                  <span className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-400 text-sm font-medium">
                    {exp.period}
                  </span>
                </div>

                <p className="text-slate-300 mb-4">{exp.description}</p>

                <h4 className="text-sm font-bold text-purple-400 mb-2">
                  Key Achievements:
                </h4>
                <ul className="space-y-1 mb-4">
                  {exp.achievements.map((achievement) => (
                    <li
                      key={achievement}
                      className="text-sm text-slate-400 flex items-start gap-2"
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-purple-400 mt-1.5 flex-shrink-0" />
                      {achievement}
                    </li>
                  ))}
                </ul>

                <div className="flex flex-wrap gap-2">
                  {exp.technologies.map((tech) => (
                    <span
                      key={tech}
                      className="px-2 py-1 text-xs rounded-full bg-slate-700/50 text-slate-300"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default Experience;
